/**
 * 判断是否为 Promise（承诺）对象。
 *
 * 即判断对象是否具有 done、fail、always、then 函数。
 *
 *     var defer = $.Deferred();
 *     isDefer(defer) //true
 *
 * @member 
 * @static
 * @param {Promise} defer Promise（承诺）对象
 * @returns {Boolean}
 */
var isDefer = function (defer) {
    return defer && typeof defer.done === 'function' && typeof defer.fail === 'function'
        && typeof defer.always === 'function' && typeof defer.then === 'function';
};

/**
 * 返回 Deferred (延迟)的 Promise（承诺）对象。
 *
 *     var defer = deferred();
 *
 * 注：该对象是参照 jQuery 的 Deferred 对象重写的，实现了大部分的功能和接口，但不能完全代替
 * @member 
 * @static
 * @returns {Promise}
 */
var deferred = function () {
    var success = [], error = [], all = [], state = 'pending',
        done, fail, resolved, rejected;

    /**
     * Promise 异步执行（承诺）对象
     *
     * 注：该对象是按 jQuery 的 Deferred 对象重写的，实现了大部分的功能和接口，性能比 jQuery 的要快100倍以上， 但不能完全代替
     * @class Promise
     */
    var def = {
        /**
         * 当 Deferred（延迟）对象解决时，调用添加处理程序
         * @param {Function} fn 一个函数，或者函数数组，当 Deferred（延迟）对象得到解决时被调用
         * @returns {Promise}
         */
        done: function (fn) {
            rejected || typeof fn === 'function' && success && success.push(fn);
            if (resolved) {
                success ? success.forEach(function (fn) {
                    fn.apply(resolved.context, resolved.args);
                }) : fn.apply(resolved.context, resolved.args);
                success = null;
                error = null;
            }
            return def;
        },
        /**
         * 当 Deferred（延迟）对象拒绝时，调用添加的处理程序
         * @param {Function} fn 一个函数，或者函数数组，当 Deferred（延迟）对象拒绝时被调用
         * @returns {Promise}
         */
        fail: function (fn) {
            resolved || typeof fn === 'function' && error && error.push(fn);
            if (rejected) {
                error ? error.forEach(function (fn) {
                    fn.apply(rejected.context, rejected.args);
                }) : fn.apply(rejected.context, rejected.args);
                success = null;
                error = null;
            }
            return def;
        },
        /**
         * 当 Deferred（延迟）对象解决或拒绝时，调用添加处理程序
         * @param {Function} fn 一个函数，或者函数数组，当 Deferred（延迟）对象得到解决或拒绝时被调用
         * @returns {Promise}
         */
        always: function (fn) {
            typeof fn === 'function' && all && all.push(fn);
            if (resolved) {
                all ? all.forEach(function (fn) {
                    fn.apply(resolved.context, resolved.args);
                }) : fn.apply(resolved.context, resolved.args);
                error = null;
                all = null;
            }
            if (rejected) {
                all ? all.forEach(function (fn) {
                    fn.apply(rejected.context, rejected.args);
                }) : fn.apply(rejected.context, rejected.args);
                success = null;
                all = null;
            }
            return def;
        },
        /**
         * 解决 Deferred（延迟）对象，并根据给定的 args 参数调用任何完成回调函数（doneCallbacks）
         * @param {Object} [args] 传递给完成回调函数（doneCallbacks）的可选的参数
         * @returns {Promise}
         */
        resolve: function (args) {
            return def.resolveWith(null, arguments);
        },
        /**
         * 解决 Deferred（延迟）对象，并根据给定的 context 和 args 参数调用任何完成回调函数（doneCallbacks）
         * @param {Object} context Context（上下文） 作为 this对象传递给完成回调函数（doneCallbacks）
         * @param {Object} [args] 传递一个可选的参数数组给完成回调函数（doneCallbacks）
         * @returns {Promise}
         */
        resolveWith: function (context, args) {
            resolved = {
                context: context,
                args: args
            };
            state = 'resolved';
            if (typeof done === 'function') {
                done.apply(context, args);
                done = null;
                fail = null;
            }
            if (success && success.length) {
                success.forEach(function (fn) {
                    fn.apply(context, args);
                });
                success = null;
                error = null;
            }
            if (all && all.length) {
                all.forEach(function (fn) {
                    fn.apply(context, args);
                });
                error = null;
                all = null;
            }
            return def;
        },
        /**
         * 拒绝 Deferred（延迟）对象，并根据给定的 args 参数调用任何失败回调函数（failCallbacks）
         * @param {Object} [args] 传递给失败回调函数（failCallbacks）的可选的参数
         * @returns {Promise}
         */
        reject: function (args) {
            return def.rejectWith(null, arguments);
        },
        /**
         * 拒绝 Deferred（延迟）对象，并根据给定的 context 和 args 参数调用任何失败回调函数（failCallbacks）
         * @param {Object} context Context（上下文） 作为 this对象传递给失败回调函数（failCallbacks ）
         * @param {Object} [args] 传递一个可选的参数数组给失败回调函数（failCallbacks ）
         * @returns {Promise}
         */
        rejectWith: function (context, args) {
            rejected = {
                context: context,
                args: args
            };
            state = 'rejected';
            if (typeof fail === 'function') {
                fail.apply(context, args);
                done = null;
                fail = null;
            }
            if (error && error.length) {
                error.forEach(function (fn) {
                    fn.apply(context, args);
                });
                success = null;
                error = null;
            }
            if (all && all.length) {
                all.forEach(function (fn) {
                    fn.apply(context, args);
                });
                success = null;
                all = null;
            }
            return def;
        },
        /**
         * 当 Deferred（延迟）对象解决，拒绝或仍在进行中时，调用添加处理程序
         *
         * 注：该方法没有提供 progressFilter 接口
         * @param {Function} doneFilter 当 Deferred（延迟）对象得到解决时被调用的一个函数
         * @param {Function} [failFilter] [可选]当 Deferred（延迟）对象拒绝时被调用的一个函数
         * @returns {Promise}
         */
        then: function (doneFilter, failFilter) {
            done = doneFilter;
            fail = failFilter;
            if (resolved) {
                typeof done === 'function' && done.apply(resolved.context, resolved.args);
                done = null;
                fail = null;
            }
            if (rejected) {
                typeof fail === 'function' && fail.apply(rejected.context, rejected.args);
                done = null;
                fail = null;
            }
            return def;
        },
        /**
         * 返回 Deferred（延迟）的 Promise（承诺）对象
         * @returns {Promise}
         */
        promise: function () {
            return def;
        },
        /**
         * 返回 Deferred（延迟）的 Promise（承诺）对象
         *
         * 注：该方法只是为了兼容而提供的，没有实现原功能
         * @returns {Promise}
         */
        progress: function () {
            return def;
        },
        /**
         * 返回 Deferred（延迟）对象的当前状态：
         *
         * "pending": Deferred 对象是尚未完成状态 (不是 "rejected" 或 "resolved" )
         *
         * "resolved": Deferred 对象是在解决状态，这意味着，deferred.resolve() 或者 deferred.resolveWith() 被对象访问和 doneCallbacks 被访问（或在被调用的过程中）
         *
         * "rejected": Deferred 对象是在被拒绝的状态，这意味着，deferred.reject() 或者 deferred.rejectWith() 被对象访问和 failCallbacks 被访问（或在被调用的过程中）
         *
         * @returns {String}
         */
        state: function () {
            return state;
        }
    };

    return def;
};

/**
 * 提供一种方法来执行一个或多个对象的回调函数， {@link Promise Deferred (延迟) 对象}通常表示异步事件。
 *
 *     utils.when(api(op)).then(function() {console.log(1);})
 *
 * @member 
 * @static
 * @param {Object...} subordinate 一个或多个延迟对象，或者普通的JavaScript对象
 * @returns {Promise}
 */
var when = function (subordinate /* , ..., subordinateN */) {
    var i = 0,
        resolveValues = Array.prototype.slice.call(arguments),
        length = resolveValues.length,
        remaining = length !== 1 || (subordinate && typeof subordinate.promise === 'function') ? length : 0,
        defer = remaining === 1 ? subordinate : deferred(),
        updateFunc = function (i, contexts, values) {
            return function (value) {
                contexts[i] = this;
                values[i] = arguments.length > 1 ? Array.prototype.slice.call(arguments) : value;
                if (!(--remaining)) {
                    defer.resolveWith(contexts, values);
                }
            };
        },
        resolveContexts = undefined;

    if (length > 1) {
        resolveContexts = [];
        resolveContexts.length = length;
        for (; i < length; i++) {
            if (resolveValues[i] && typeof resolveValues[i].promise === 'function') {
                resolveValues[i].promise().done(updateFunc(i, resolveContexts, resolveValues)).fail(defer.reject);
            } else {
                --remaining;
            }
        }
    }
    if (!remaining) {
        defer.resolveWith(resolveContexts, resolveValues);
    }
    return defer.promise();
};



export default {
    when(subordinate) {
        return when(subordinate)
    },
    deferred(){
        return deferred()
    }
}



// WEBPACK FOOTER //
// ./src/utils/when.js